import { Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useEffect } from "react";
import { useVideo } from "../../../../../context/juno/VideoContext";
import { ColumnBox } from "../../../../../utils/styledBox";
import ImageUpload from "../ImageUpload";
import AudioUpload from "../AudioUpload";
import AspectRatioIcons from "../AspectRatioIcons";
import ModelVersionSelectBox from "../ModelVersionSelectBox";

const ParamsHedra = () => {
  const { t } = useTranslation();
  const { aiEngine, modelVersion, updateParams, audio1, setAudio1, image1, setImage1 } = useVideo();

  const aspectRatioList = ["AUTO", "1:1", "16:9", "9:16"];

  useEffect(() => {
    const engine = aiEngine as "HEDRA";

    // パラメータの初期化 - Character3モデルを使用、720P固定
    if (modelVersion[engine] !== "CHARACTER3") {
      updateParams(engine, "modelVersion", "CHARACTER3");
    }
  }, [aiEngine, updateParams, modelVersion]);

  return (
    <ColumnBox sx={{ gap: 4 }}>
      <ColumnBox>
        {/* モデルバージョン */}
        <Typography variant="body2" mb={1}>
          {t("juno.video.ai.model")}
        </Typography>
        <ModelVersionSelectBox onChange={(value) => updateParams("HEDRA", "modelVersion", value)} />
      </ColumnBox>

      {/* アップロード */}
      <ColumnBox sx={{ justifyContent: "center" }}>
        <Typography variant="body2" mb={1}>
          {t("juno.video.params.uploadFace")}
        </Typography>
        <ImageUpload image={image1} setImage={setImage1} />
      </ColumnBox>

      <ColumnBox sx={{ justifyContent: "center" }}>
        <Typography variant="body2" mb={1}>
          {t("juno.video.params.audio")}
        </Typography>
        <AudioUpload audio={audio1} setAudio={setAudio1} />
      </ColumnBox>

      <ColumnBox>
        {/* アスペクト比 */}
        <AspectRatioIcons aspectRatioList={aspectRatioList} />
      </ColumnBox>
    </ColumnBox>
  );
};

export default ParamsHedra;
